import { FC, useState, useEffect } from 'react';
import cn from 'classnames';
import { IGifts, IGift } from 'base/interfaces/product';
import { ProdGiftsTip } from '@pro/product/ProdGifts/ProdGiftsTip';
import { Modal, Drawer, Button } from 'antd';
import { IProdGiftsDetailProps, ProdGiftsDetail } from '@pro/product/ProdGifts/ProdGiftsDetail';
import { IAddCartInstance } from '@base/product/useAddCart';
import styles from './index.module.less';
import Iconfont from '@base/lib/Iconfont';

type IProps = {
    addCart: IAddCartInstance;
};

const ProdGiftsMain: FC<IProps> = props => {
    const { addCart } = props;
    const { shownVariant, checkedGift, setCheckedGift } = addCart;
    const { activity, detail } = shownVariant.gifts as IGifts

    const [visible, setVisible] = useState<boolean>(false);
    const [checkedId, setCheckedId] = useState<string>(checkedGift!.variantId);

    const onCancel = () => setVisible(false);

    const onSubmit = () => {
        setCheckedGift(detail.options.find(item => item.variantId === checkedId));
        setVisible(false);
    };

    const detailProps: IProdGiftsDetailProps = {
        ...detail,
        checkedId,
        setCheckedId,
        onSubmit
    };

    useEffect(() => {
        if (visible) {
            setCheckedId(checkedGift!.variantId);
        }
    }, [visible]);

    return (
        <>
            <ProdGiftsTip
                {...activity}
                checkedGift={checkedGift as IGift}
                onShowDetail={() => setVisible(true)}
            />

            {process.env.NEXT_PUBLIC_TERMINAL === 'm' ? (
                <Drawer
                    className={styles.drawer}
                    open={visible}
                    onClose={onCancel}
                    placement="bottom"
                    height="100%"
                    title={detail.drawTitle}
                    closeIcon={<Iconfont className="icon-x"/>}
                    footer={
                        <Button
                            type={'primary'}
                            className={styles.btn}
                            onClick={onSubmit}
                        >
                            {detail.btnText}
                        </Button>
                    }
                >
                    <ProdGiftsDetail
                        {...detailProps}
                        showSubmitBtn={false}
                    />
                </Drawer>
            ) : (
                <Modal
                    className={cn(styles.modal, 'wrapper')}
                    destroyOnClose={true}
                    width={1240}
                    open={visible}
                    onCancel={onCancel}
                    footer={false}
                    centered
                >
                    <ProdGiftsDetail {...detailProps}/>
                </Modal>
            )}
        </>
    )
};


export const ProdGifts: FC<IProps> = ({ addCart }) => {
    const { shownVariant, checkedGift } = addCart;
    return !shownVariant.gifts || !checkedGift ? null : <ProdGiftsMain addCart={addCart}/>
};
